import React from 'react';
import PropTypes from 'prop-types';
export { LinkCopied } from './link-copied/link-copied';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import LinkIcon from '../../../../../icons/compiled/components/LinkIcon';
import parentStyles from '../styles.scss';
import styles from './styles.scss';
export class Link extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { canShareContent } = this.props;
            if (canShareContent) {
                this.copyToClipboard();
            }
            this.props.onClick();
        };
        this.saveRef = (ref) => {
            this.ref = ref;
        };
    }
    copyToClipboard() {
        if (document.queryCommandSupported('copy')) {
            this.ref.select();
            document.execCommand('copy');
        }
    }
    render() {
        const { dataHook, className, ariaLabel, instanceInfo, tooltip } = this.props;
        return (React.createElement(Tooltip, { content: tooltip },
            React.createElement("button", { type: "button", className: className, "data-hook": dataHook, onClick: this.handleClick, "aria-label": ariaLabel },
                React.createElement(InlineIcon, { icon: React.createElement(LinkIcon, null), className: parentStyles.icon, "aria-hidden": "true" }),
                instanceInfo && (React.createElement("input", { type: "text", ref: this.saveRef, tabIndex: "-1", readOnly: true, className: styles.utilityInput, value: instanceInfo.siteUrl, "aria-hidden": "true" })))));
    }
}
Link.propTypes = {
    dataHook: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    tooltip: PropTypes.node,
    canShareContent: PropTypes.bool,
    ariaLabel: PropTypes.string,
    instanceInfo: PropTypes.shape({
        instanceId: PropTypes.string,
        componentId: PropTypes.string,
        sitePageId: PropTypes.string,
        siteUrl: PropTypes.string,
    }),
};
//# sourceMappingURL=link.js.map